function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.90918 8.17929V0.0585938H11.2568V9.40523H8.92108H8.24389C7.63543 9.40523 6.90918 8.79718 6.90918 8.17929Z",
  fill: "#707274"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.8669 9.40547V0H18.2146V9.40547H13.8669Z",
  fill: "#707274"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4275 16.0354H13.8671H7.2917C3.27785 16.0354 0 12.7499 0 8.74836V0H4.34754V8.73859C4.34754 10.3568 5.68225 11.6906 7.30154 11.6906H8.92083H13.818H18.2146V16.0354H15.4275Z",
  fill: "#707274"
});

function SvgWindfallLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindfallLogo);
export default __webpack_public_path__ + "static/media/windfall_logo.7190dba9.svg";
export { ForwardRef as ReactComponent };